/**
 * İade ve ret bildirimi gönderene (ADR 0116 Ek): kayıt sayfasının bandı, zil maddesi ve panoda
 * "Returned to you". ISM formunun metinleri `forms.record.returned*` ve `forms.returned`'dadır;
 * diğer akışlar bunları kullanır.
 */
export const returnedEn = {
  title: {
    returned: 'Returned for correction',
    rejected: 'Rejected',
    revoked: 'Revoked by the office',
    queried: 'Queried by the office',
  },
  text: {
    returned: 'Returned by {{by}} on {{at}}.',
    returnedOffice: 'Returned by the office ({{by}}) on {{at}}.',
    rejected: 'Rejected by {{by}} on {{at}}.',
    rejectedOffice: 'Rejected by the office ({{by}}) on {{at}}.',
  },
  reason: 'Reason: {{reason}}',
  hint: 'Correct the record and submit it again.',
  finalHint: 'This decision is final; it cannot be resubmitted.',
  bell: {
    returned: '{{record}} returned to you',
    rejected: '{{record}} rejected',
  },
  badge: {
    returned: 'Returned',
    rejected: 'Rejected',
  },
  modules: {
    ism_forms: 'ISM form',
    work_records: 'Work record',
    postponements: 'Postponement',
    defects: 'Defect',
    hse_reports: 'HSEQ report',
    daily_reports: 'Daily report',
    cash: 'Cash',
    risk_assessments: 'Risk assessment',
    ra_operations: 'Operation RA',
    purchasing: 'Requisition',
    documents: 'Document revision',
    ra_library: 'RA library',
  },
};

export const returnedTr: typeof returnedEn = {
  title: {
    returned: 'Düzeltme için iade edildi',
    rejected: 'Reddedildi',
    revoked: 'Ofis geri çevirdi',
    queried: 'Ofis sorguladı',
  },
  text: {
    returned: '{{by}} {{at}} tarihinde iade etti.',
    returnedOffice: 'Ofis ({{by}}) {{at}} tarihinde iade etti.',
    rejected: '{{by}} {{at}} tarihinde reddetti.',
    rejectedOffice: 'Ofis ({{by}}) {{at}} tarihinde reddetti.',
  },
  reason: 'Gerekçe: {{reason}}',
  hint: 'Kaydı düzeltip yeniden gönderin.',
  finalHint: 'Bu karar kesindir; yeniden gönderilemez.',
  bell: {
    returned: '{{record}} size iade edildi',
    rejected: '{{record}} reddedildi',
  },
  badge: {
    returned: 'İade',
    rejected: 'Ret',
  },
  modules: {
    ism_forms: 'ISM formu',
    work_records: 'İş kaydı',
    postponements: 'Erteleme',
    defects: 'Arıza',
    hse_reports: 'HSEQ raporu',
    daily_reports: 'Günlük rapor',
    cash: 'Kasa',
    risk_assessments: 'Risk değerlendirmesi',
    ra_operations: 'Operasyon RA',
    purchasing: 'Malzeme talebi',
    documents: 'Doküman revizyonu',
    ra_library: 'RA kütüphanesi',
  },
};
